'use client'

import React, { useRef, useState } from 'react'

import { useTranslations } from 'next-intl'
import { IBranch } from '@/_types'
import { Box, Text, VStack } from '@chakra-ui/react'
import NearestBranchControl from './components/NearestBranchControl'
import BranchesContent from '../../Branches/_components/content'
import { useSaveBranchData } from '@/_hooks/useSaveBranchData'
import { formatPhoneNumber } from '@/_utils/formatPhoneNumber'
import { Button } from '@/components/ui/button'
import YandexMap from './components/Yandex'
import { Link } from '@/i18n/navigation'
import BottomSheet from '../../Sheet'
import { IProps } from './_types'
import './style.css'
import { useActiveBrand } from '@/_hooks/useActiveBrand'

function Mobile({ isSelected = false, data, onClose, onConfirm }: IProps) {
  const [branch, setBranch] = useState<IBranch | null>(null)
  const [nearestTwoBranches, setNearestTwoBranches] = useState<IBranch[]>([])
  const t = useTranslations()
  const saveBranch = useSaveBranchData()
  const mapRef = useRef<any>(null)
  const shipperId = useActiveBrand()

  const handleConfirm = () => {
    if (branch) {
      if (onConfirm) {
        onConfirm({
          id: branch.id,
          menu_id: branch.menu_id || '',
          address: branch.address,
          name: branch.name,
          location: branch.location,
          slug: branch.slug,
          future_delivery_order_time: branch.future_delivery_order_time,
          future_self_pickup_order_time: branch.future_self_pickup_order_time,
          work_hour_start: branch.work_hour_start,
          work_hour_end: branch.work_hour_end,
          is_work_24_7: branch.is_work_24_7,
          delivery_time: branch.delivery_time,
          shipper_id: shipperId,
        })
      }
      else {
        saveBranch({
          id: branch.id,
          menu_id: branch.menu_id || '',
          address: branch.address,
          name: branch.name,
          location: branch.location,
          slug: branch.slug,
          future_delivery_order_time: branch.future_delivery_order_time,
          future_self_pickup_order_time: branch.future_self_pickup_order_time,
          work_hour_start: branch.work_hour_start,
          work_hour_end: branch.work_hour_end,
          is_work_24_7: branch.is_work_24_7,
          delivery_time: branch.delivery_time,
          shipper_id: shipperId,
        })
        setBranch(null)
        onClose()
      }
    }
  }

  const pointTo = (branch: IBranch | null) => {
    if (!mapRef.current || !branch) return

    const adjustedLat = branch.location.lat - 0.002
    const adjustedLong = branch.location.long - 0.0004

    mapRef.current.setCenter([adjustedLat, adjustedLong], 16, { duration: 300 })
  }

  return (
    <>
      <YandexMap
        mapRef={mapRef}
        data={data}
        onSelect={(branch) => {
          pointTo(branch)
          setBranch(branch)
          setNearestTwoBranches([])
        }}
      />
      <NearestBranchControl
        onSelectBranch={(branch) => {
          pointTo(branch)
          setBranch(branch)
        }}
        setNearestTwoBranches={setNearestTwoBranches}
      />
      <BottomSheet
        zIndex={1500}
        isOpen={Boolean(branch)}
        onClose={() => setBranch(null)}
      >
        {nearestTwoBranches?.length > 0 ? (
          <VStack alignItems={'start'} gap={4} px={4}>
            <BranchesContent
              data={nearestTwoBranches}
              selectedBranch={branch}
              onSelectBranch={(branch) => {
                pointTo(branch)
              }}
              setSelectedBranch={setBranch}
            />
          </VStack>
        ) : (
          <VStack color='text' alignItems={'start'} gap={4} px={4}>
            <Text fontSize={20} fontWeight={700}>
              {branch?.name}
            </Text>
            <Box>
              <Text fontSize={'sm'} color='text.muted'>
                {t('schedule')}:
              </Text>
              <Text>
                {branch?.open_time}-{branch?.close_time}
              </Text>
            </Box>
            <Box>
              <Text fontSize={'sm'} color='text.muted'>
                {t('address')}:
              </Text>
              <Text>{branch?.address}</Text>
            </Box>
          </VStack>
        )}

        {isSelected ? (
          <Box p={4}>
            <Button
              fontSize={16}
              size={'xl'}
              height={'56px'}
              bg='primary'
              color='primary.text'
              _hover={{ bg: 'primary.hover' }}
              w={'full'}
              onClick={handleConfirm}
            >
              {t('select')}
            </Button>
          </Box>
        ) : (
          <VStack p={4} gap={3} alignItems={'start'}>
            <Link
              style={{ width: '100%' }}
              target='_blank'
              href={`https://yandex.com/maps/?ll=${branch?.location?.long}%2C${branch?.location?.lat}&mode=whatshere&whatshere%5Bpoint%5D=${branch?.location?.long}%2C${branch?.location?.lat}&z=14`}
            >
              <Button
                fontSize={16}
                size={'xl'}
                height={'56px'}
                bg='primary'
                color='primary.text'
                _hover={{ bg: 'primary.hover' }}
                w={'full'}
              >
                {t('build_route')}
              </Button>
            </Link>
            <Link style={{ width: '100%' }} href={`tel:${branch?.phone}`}>
              <Button
                fontSize={16}
                size={'xl'}
                height={'56px'}
                bg='background'
                color='text'
                variant={'subtle'}
                w={'full'}
              >
                {formatPhoneNumber(branch?.phone || '')}
              </Button>
            </Link>
          </VStack>
        )}
      </BottomSheet>
    </>
  )
}

export default Mobile
